import SessionManagerRecord, { SessionManagerRecordSource } from '../lib/SessionManagerRecord.js';
import ApplicationToken from './ApplicationToken.js';
import ApplicationUser from './ApplicationUser.js';
function removeCircularUser(relationship) {
    relationship.user = { id: relationship.user.id };
    return relationship;
}
/**
 */
class ApplicationSession extends SessionManagerRecord {
    initialize(props) {
        super.initialize(props);
        // Flip the Profile <-> User relationship for ease-of-access
        if (props && props.profile) {
            const { user } = props.profile;
            delete props.profile.user;
            user.profile = props.profile;
            user.accountMemberships = user.accountMemberships.map(removeCircularUser);
            user.communications = user.communications.map(removeCircularUser);
            this.user = new ApplicationUser(user);
        }
    }
    /**
     * @return {Promise<ApplicationSession>}
     */
    async signOut() {
        return this.delete();
    }
    /**
     * @param {ApplicationSession} session
     * @return {Promise<ApplicationSession>}
     * @private
     */
    static async getToken(session) {
        if (session) {
            return ApplicationToken.find()
                .then((applicationToken) => {
                if (!applicationToken)
                    throw new Error('No token found');
                session.user.setToken(applicationToken);
                return session;
            });
        }
        return Promise.resolve(session);
    }
    /**
     * @return {Promise<ApplicationSession>}
     */
    static async check() {
        return ApplicationSession.find()
            .then((session) => {
            if (session)
                return ApplicationSession.getToken(session);
            return null;
        });
    }
    /**
     * Sign in while including credentials (faciliates setting the cookie in response)
     * @param {object} props
     * @param {string} props.provider
     * @param {string} props.token
     * @return {Promise<ApplicationSession>}
     */
    static async signIn(props) {
        return ApplicationSession.create(props)
            .then(ApplicationSession.getToken);
    }
}
ApplicationSession.$AR = {
    url: '',
    SourceClass: SessionManagerRecordSource,
    options: {
        responseRecordsPropertyName: 'logins',
    },
};
export default ApplicationSession;
